// extracted by mini-css-extract-plugin
module.exports = {"input":"ClientProfile_input_nuI1O","infoLabel":"ClientProfile_infoLabel_3Mx9X","infoText":"ClientProfile_infoText_6WwlR"};